<template>
  <div id="about" class="content md-gutter md-alignment-center-center">
    <div class="md-layout-item">
      <h1>{{ $t("About") }}</h1>
      <md-list style="background: none;">
        <md-list-item><b>{{ $t("complete-name") }}:</b> <span>{{ $t("complete-name-value") }}</span></md-list-item>
        <md-list-item><b>{{ $t("academic-formation") }}:</b></md-list-item>
        <md-list-item>- {{ $t("academic-formation-value-0") }} </md-list-item>
        <md-list-item>- {{ $t("academic-formation-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("academic-formation-value-2") }} </md-list-item>
        <md-list-item>- {{ $t("academic-formation-value-3") }} </md-list-item>
        <md-list-item><b>{{ $t("research-experience") }}:</b></md-list-item>
        <md-list-item>- {{ $t("research-experience-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("research-experience-value-2") }} </md-list-item>
        <md-list-item><b>{{ $t("professional-experience") }}:</b></md-list-item>
        <md-list-item>- {{ $t("professional-experience-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("professional-experience-value-2") }} </md-list-item>
        <md-list-item><b>{{ $t("courses") }}:</b></md-list-item>
        <md-list-item>- {{ $t("courses-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("courses-value-2") }} </md-list-item>
        <md-list-item><b>{{ $t("events") }}:</b></md-list-item>
        <md-list-item>- {{ $t("events-value-0") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-00") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-2") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-3") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-4") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-5") }} </md-list-item>
        <md-list-item>- {{ $t("events-value-6") }} </md-list-item>
        <md-list-item><b>{{ $t("competitions") }}:</b></md-list-item>
        <md-list-item>- {{ $t("competitions-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("competitions-value-2") }} </md-list-item>
        <md-list-item>- {{ $t("competitions-value-3") }} </md-list-item>
        <md-list-item>- {{ $t("competitions-value-4") }} </md-list-item>
        <md-list-item>- {{ $t("competitions-value-5") }} </md-list-item>
        <md-list-item><b>{{ $t("awards") }}:</b></md-list-item>
        <md-list-item>- {{ $t("awards-value-0") }} </md-list-item>
        <md-list-item>- {{ $t("awards-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("awards-value-2") }} </md-list-item>
        <md-list-item><b>{{ $t("languages") }}:</b></md-list-item>
        <md-list-item>- {{ $t("languages-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("languages-value-2") }} </md-list-item>
        <md-list-item><b>{{ $t("habilities") }}:</b></md-list-item>
        <md-list-item>- {{ $t("habilities-value-1") }} </md-list-item>
        <md-list-item>- {{ $t("habilities-value-2") }} </md-list-item>
        <md-list-item><b>{{ $t("personal-characteristics") }}:</b></md-list-item>
        <md-list-item>- {{ $t("personal-characteristics-value-1") }} </md-list-item>
      </md-list>
    </div>
  </div>
</template>

<script>

export default {
  name: 'About',
  title: 'Fabrício Ceschin - About',
  props: {
    // msg: String,
    // num: Number
  },
  mounted() {
    this.$ga.page('/about');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

/* > medium */
@media (min-width: 1279px) {
  #about .md-list-item-content.md-ripple.md-disabled {
    display: block !important;
  }
}

/* < medium */
@media (max-width: 1278px) {
  #about .md-list-item-content.md-ripple.md-disabled span{
    text-align: right;
  }
}

#about h1 {
  text-align:center;
}

#about .md-button-clean {
  white-space: inherit;
}

</style>
